import React from "react";
import { DeveloperInfo } from "../data/data.json";
function Footer(props) {
  return (
    <div id="footer" style={{ height: 30 }}>
      <div className="container text-center">
        <p>
          &copy; 2020 Zippy Link ICT Services. Developed by{" "}
          <a
            href={DeveloperInfo.website}
            rel="nofollow"
            style={{ color: "#191970" }}
          >
            {DeveloperInfo.name}
          </a>
        </p>
      </div>
    </div>
  );
}

export default Footer;
